import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { useForm } from 'react-hook-form';
import CollapsibleGroup from 'components/organisms/CollapsibleGroup';
import Typography from 'components/atoms/Typography';
import { items, getEquivalents, growth, publicSectorShare } from './data';
import SelectNative from '../../atoms/SelectNative/SelectNative';
import s from './VEFSCalculator.css';

const formatNumber = (num, noDigits = 2) =>
  num.toLocaleString('sv-SE', {
    maximumSignificantDigits: noDigits,
    minimumSignificantDigits: noDigits,
    maximumFractionDigits: num > 1e6 ? 1 : 0,
    minimumFractionDigits: 0,
    roundingPriority: 'lessPrecision',
    notation: num > 1e6 ? 'compact' : 'standard',
    compactDisplay: 'long',
  });

const NumberDisplay = ({ header, value }) => (
  <div className={s.numberDisplay}>
    <span>{header}</span>
    <span>{value}</span>
  </div>
);

const VEFSCalculator = () => {
  const { register, watch } = useForm();
  const activeItem = watch('item', items[0]);
  const equivalents = getEquivalents(activeItem);

  return (
    <div className={s.vefsCalculator}>
      <SelectNative name="item" label="Välj roll" register={register()} defaultValue={items[0]}>
        {items.map(item => (
          <option value={item}>{item}</option>
        ))}
      </SelectNative>
      <div className={s.numbers}>
        <NumberDisplay
          header="Vid 2,5% tillväxt"
          value={`${formatNumber(equivalents.SN)} ${equivalents.unit}`}
        />
        <NumberDisplay
          header="Vid 1,8% tillväxt"
          value={`${formatNumber(equivalents.KI)} ${equivalents.unit}`}
        />
        <NumberDisplay header="Skillnad" value={`${formatNumber(equivalents.delta)} ${equivalents.unit}`} />
      </div>
      <CollapsibleGroup
        className={s.collapsible}
        readMoreText="Så har vi räknat"
        readLessText="Så har vi räknat"
      >
        <Typography variant="paragraphSmall">
          Med en genomsnittlig tillväxt på 2,5 procent från och med 2025 skulle Sveriges totala inkomster
          (BNP) bli {formatNumber(growth.SN - growth.KI, 3)} kronor större 2035 jämfört med om vi håller den
          tillväxttakt på 1,8 procent som ligger i Konjunkturinstitutets prognoser. Ungefär{' '}
          {formatNumber(publicSectorShare * (growth.SN - growth.KI), 3)} (
          {formatNumber(publicSectorShare * 100, 3)} procent) av den större inkomsten kan antas tillfalla
          staten, regionerna och kommunerna. Det motsvarar ungefär {formatNumber(equivalents.delta)}{' '}
          {equivalents.unit}.
        </Typography>
        <Typography variant="paragraphSmall">Samtliga belopp är enligt 2024 års priser.</Typography>
      </CollapsibleGroup>
    </div>
  );
};

export default withStyles(s)(VEFSCalculator);
